import React from 'react';
import { getAppContext } from '~/lib/AppContext';
import UnmountHelper from '~/lib/helper/UnmountHelper';

export default class KeepAlive extends React.Component {
    refreshAuthInterval = 1000 * 60 * 5; // 5 minutes

    unmountHelper = new UnmountHelper(this);

    doRefreshAuth() {
        void getAppContext().siteApiClient.keepAlive();
    }

    componentDidMount(): void {
        this.doRefreshAuth(); // once on mount
        this.unmountHelper.intervalUntilUnmounted(() => {
            this.doRefreshAuth();
        }, this.refreshAuthInterval); // then every 5 minutes
    }

    render() {
        return null; // we don't show anything
    }
}
